module.exports = __webpack_public_path__ + "images/fff6432e.img_chs_4.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/img_chs_4.jpg
// module id = 344
// module chunks = 0